// This is api.js

  // ^^^^^^^ WORKING API FUNCTION  ^^^^^  

   export const createStripePaymentLink = async (idToken) => {
       const res = await fetch('https://1azyop0jo8.execute-api.eu-west-2.amazonaws.com/dev/create-payment-link', {
         method: 'POST',
         headers: {
           Authorization: `Bearer ${idToken}`,
         },
       });
       if (!res.ok) throw new Error('Failed to create Stripe payment link');
       const { url } = await res.json();
       return url;
     };

  
export const fetchPublicFmpMetrics = async (symbol, type = 'ratios') => {
  // const url = `https://d1imbma6yo5wmc.cloudfront.net/public-fmp-metrics?symbol=${symbol}&type=${type}`;
   // >>>>>>>>>>>>>>>>>>>>>> Code to add >>>>>>>>>>>>
   const url = `/public-fmp-metrics?symbol=${symbol}&type=${type}`;
   // <<<<<<<<<<<<<<<<<<<<<<< Code to add <<<<<<<<<<<
 
  const res = await fetch(url);

  if (!res.ok) {
    throw new Error(`Failed to fetch ${type} data for ${symbol}`);
  }

  const text = await res.text();
  try {
    return JSON.parse(text);
  } catch (err) {
    console.error(`Invalid JSON for ${symbol}:`, text.slice(0, 200));
    throw new Error(`Response for ${symbol} is not valid JSON`);
  }
};

export const fetchFinancialRatios = async (symbol) => {
  const normalizedSymbol = symbol?.trim().toUpperCase();

  if (!normalizedSymbol) {
    throw new Error('A stock symbol is required to fetch financial ratios');
  }

  const res = await fetch(`/financial-ratios/${normalizedSymbol}.json`);

  if (!res.ok) {
    throw new Error(`Failed to fetch financial ratios for ${normalizedSymbol}`);
  }

  const text = await res.text();

  try {
    return JSON.parse(text);
  } catch (err) {
    console.error(`Invalid financial ratio JSON for ${normalizedSymbol}:`, text.slice(0, 200));
    throw new Error(`Financial ratios response for ${normalizedSymbol} is not valid JSON`);
  }
};

  //  export const fetchHistoricalData = (symbol) =>
  //    fetchPublicFmpMetrics(symbol, 'historical').then((data) => data.historical || []);

  export const fetchHistoricalData = (symbol) =>
  fetchPublicFmpMetrics(symbol, 'historical').then((data) => {
    // New FMP stable endpoint returns a plain array:
    // [ { symbol, date, open, high, low, close, volume, vwap, changePercent }, ... ]
    if (Array.isArray(data)) {
      return data;
    }

    // Backward-compatibility in case the backend ever wraps it:
    if (data && Array.isArray(data.historical)) {
      return data.historical;
    }

    console.error('Unexpected historical data shape:', data);
    return [];
  });
  
   export const fetchMetrics = (symbol) =>
     fetchPublicFmpMetrics(symbol, 'ratios').then((data) => data?.[0] || null);


export const fetchStockList = async (idToken) => {
      const headers = {};
      if (idToken) {
        headers.Authorization = `Bearer ${idToken}`;
      }
      const res = await fetch(
        "https://1azyop0jo8.execute-api.eu-west-2.amazonaws.com/dev/list-stocks-search",
        { headers }
      );
      if (!res.ok) throw new Error("Failed to fetch stock list");
      return res.json(); // array of { symbol, name }
    };

const fetchIncomeStatementFile = async (symbol, filename, datasetLabel) => {
  const normalizedSymbol = symbol?.trim().toUpperCase();

  if (!normalizedSymbol) {
    throw new Error(`A stock symbol is required to fetch ${datasetLabel} data`);
  }

  const res = await fetch(`/data/${normalizedSymbol}/${filename}`);

  if (!res.ok) {
    throw new Error(`Failed to fetch ${datasetLabel} data for ${normalizedSymbol}`);
  }

  const text = await res.text();

  try {
    return JSON.parse(text);
  } catch (err) {
    console.error(`Invalid ${datasetLabel} JSON for ${normalizedSymbol}:`, text.slice(0, 200));
    throw new Error(`${datasetLabel} response for ${normalizedSymbol} is not valid JSON`);
  }
};

const fetchSecIncomeStatementFile = async (symbol) => {
  const normalizedSymbol = symbol?.trim().toUpperCase();

  if (!normalizedSymbol) {
    throw new Error('A stock symbol is required to fetch income statement data');
  }

  const res = await fetch(`/income-statements/${normalizedSymbol}.json`);

  if (!res.ok) {
    throw new Error(`Failed to fetch income statement data for ${normalizedSymbol}`);
  }

  const text = await res.text();

  try {
    return JSON.parse(text);
  } catch (err) {
    console.error(`Invalid income statement JSON for ${normalizedSymbol}:`, text.slice(0, 200));
    throw new Error(`Income statement response for ${normalizedSymbol} is not valid JSON`);
  }
};

export const fetchIncomeStatement = (symbol) =>
  fetchSecIncomeStatementFile(symbol);

export const fetchIncomeStatementGrowth = (symbol) =>
  fetchIncomeStatementFile(
    symbol,
    'income_statement_growth.json',
    'income statement growth'
  );
